import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { FormattedMessage } from 'react-intl'
import { Products } from "../../../listing/components/list/index.jsx";
import { withList } from "../../../../components/list";
import { useEffect,useState } from "react";
import { fetchByMenu } from "../../../../../api";
import Affix from "../../../../components/affix";
// import data from "./mock";

const YouLikesItem = (props) =>{
    useStyles(classes);
    const {products, titleStyle, titleClass, affixHead, affixHeadOffset, sensors, noBorderTop, noAddWish} = props;


    return (
        <div className={`${classes.YouMayAlsoLikes} ${!noBorderTop ? classes.GolbalBorderTop: ''}`}>
            {
                affixHead ?
                <Affix offsetTop={affixHeadOffset}>
                    <div className={classes.Hd} style={{...titleStyle}}>
                        <FormattedMessage id="you_may_also_likes" defaultMessage="You May Also Like" />
                    </div>
                </Affix>:
                <div className={`${classes.Hd}`} style={{...titleStyle}}>
                    <span className={`${titleClass == 'titleLine'? classes.TitleLine: ''}`}>
                        <FormattedMessage id="you_may_also_likes" defaultMessage="You May Also Like" />
                    </span>
                </div>
            }
            <div>
                {
                    products?.length > 0 && <Products 
                        products={products} 
                        sensors={sensors}
                        column="You May Also Like"
                        noAddWish={noAddWish}
                    />
                }
            </div>
        </div>
    )
}

const YouLikesProducts = withList(YouLikesItem);

const ProductYouLikes = props =>{
    const { titleStyle, titleClass, limitRequest, affixHead, affixHeadOffset, sensors, noBorderTop, noAddWish } = props
    const LIMIT = limitRequest || 20
    const [loading, setLoading] = useState(false)
    const [products,setProducts] = useState(null);
    const [skip,setSkip] = useState(0);
    const [finished,setFinished] = useState(false);
    // const mockData = data

    useEffect(async () =>{
        setLoading(true)
        let products = await fetchByMenu({skip: skip, code: 'APP0010', limit: LIMIT}).then(data => data.result).catch(data => {
            console.error(data)
            return []
        });
        // let products = mockData?.result
        setProducts(products);
        setSkip((preValue) =>preValue += LIMIT);
        setLoading(false)
        setFinished(!!!products || products?.length < 1 || limitRequest);
    },[]);

    const loadHandle = async () =>{
        if(limitRequest) return
        setLoading(true)
        const products = await fetchByMenu({skip: skip, code: 'APP0010', limit: LIMIT}).then(data => data.result).catch(data => {
            console.error(data)
            return []
        })

        setProducts(preValue =>[...preValue,...products]);
        setSkip((preValue) =>preValue += LIMIT);
        setLoading(false)
        setFinished(!!!products || products?.length < 1);
    }

    return <YouLikesProducts
                titleClass={titleClass}
                titleStyle={titleStyle}
                noBorderTop={noBorderTop}
                noAddWish={noAddWish}
                loading={loading}
                products={products}
                request={loadHandle}
                finished={finished}
                affixHead={affixHead}
                affixHeadOffset={affixHeadOffset}
                sensors={sensors}
                />
}

export default ProductYouLikes;